import { PlanTypes } from '@gonfalon/billing/types';
import { getDocumentationUrl } from '@gonfalon/docs/documentationUrl';
import { enableSelfServeObservability, enableSpecialRatesPlanFeature } from '@gonfalon/dogfood-flags/dogfood-flags';

import type { Plan } from '../../../plan/types';

import { foundationPlan } from './foundationPlan';
import { aiRunsFeature } from './products';

export const foundationPlanPostTrial: Plan = {
  ...foundationPlan,
  id: `${PlanTypes.FOUNDATION2023}-post-trial`,
  marketingCopy: {
    ...foundationPlan.marketingCopy,
    featuresHeader: 'Foundation plan includes',
    features: [
      { text: 'Unlimited projects and environments' },
      { text: 'Unlimited feature flags' },
      {
        text: '5 service connections per month',
        tooltip: {
          text: '1 server-side SDK connected to a LaunchDarkly environment for one month',
          ctaTarget: getDocumentationUrl('home/account/service-connections'),
        },
      },
      {
        text: 'K8s, Serverless, Python & Ruby',
        tooltip: {
          text: "Kubernetes, serverless, and per-request runtimes like Python and Ruby open lots of short-lived server connections. We discount service connection pricing for these architectures so connection churn doesn't inflate your bill. Tell us your setup and we'll send exact rates.",
          ctaText: 'Get discounted rates',
          ctaAction: 'contact_sales',
        },
        gatedByFlag: enableSpecialRatesPlanFeature,
      },
      {
        text: '1K client-side MAU',
        tooltip: {
          text: 'Each client-side user or device creates a client-side MAU',
          ctaTarget: getDocumentationUrl('home/account/calculating-billing'),
        },
      },
      aiRunsFeature,
      {
        text: '100K experimentation MAU',
        tooltip: {
          text: 'Monthly number of users available to be targeted in Experiments',
        },
      },
      { text: 'A/B tests and experimentation' },
      {
        text: 'First-class mobile SDKs, attributes and targeting',
      },
      { text: 'Comprehensive audit log' },
      {
        text: '5K sessions',
        tooltip: {
          text: '1 recorded user session (a single instance of a tab) captured and stored for one month',
          ctaTarget: getDocumentationUrl('home/observability/session-replay'),
        },
        gatedByFlag: enableSelfServeObservability,
      },
      {
        text: '5K errors',
        tooltip: {
          text: '1 unique instance of an error or exception captured and stored for one month',
          ctaTarget: getDocumentationUrl('home/observability/errors'),
        },
        gatedByFlag: enableSelfServeObservability,
      },
      {
        text: '10M traces',
        tooltip: {
          text: 'A single span ingested, stored, and searchable for one month',
          ctaTarget: getDocumentationUrl('home/observability/traces'),
        },
        gatedByFlag: enableSelfServeObservability,
      },
      {
        text: '10M logs',
        tooltip: {
          text: 'A single log line ingested, stored, and searchable for one month',
          ctaTarget: getDocumentationUrl('home/observability/logs'),
        },
        gatedByFlag: enableSelfServeObservability,
      },
    ],
  },
};
